import styled from "styled-components";
import { mediaMaxWidth } from "../../utils/mediaQueriesTemplate";

export const SuccessMessageWrapper = styled.div`
  position: fixed;
  display: flex;
  flex: 1;
  justify-content: space-between;
  align-items: center;
  padding: 0 30px;
  top: ${(props) => (props.showMessage ? "116px" : "-100px")};
  border-bottom: 1px solid #6fcf97;
  left: 60px;
  background: rgba(111, 207, 151, 1);
  color: #fff;
  z-index: 2;
  width: calc(100% - 60px);
  height: 60px;
  transition: 0.1s ease-in-out;

  ${mediaMaxWidth.tablet`
    left: 0;
    width: 100%;
    padding: 0 15px;
  `}
`;

export const Emoji = styled.div``;
